import introspectionResult from "@penfold/graphql/generated/fragmentTypes.json";
import {
  defaultDataIdFromObject,
  InMemoryCache,
  IntrospectionFragmentMatcher,
} from "apollo-cache-inmemory";
import { ApolloClient } from "apollo-client";
import { ApolloLink } from "apollo-link";
import DebounceLink from "apollo-link-debounce";
import withApollo from "next-with-apollo";
import {
  createErrorLink,
  createPenfoldLink,
  createPrismicLink,
  createRetryLink,
  OperationCounterLink,
} from "./links";

const DEFAULT_DEBOUNCE_TIMEOUT = 100;

const isPrismicQuery = (operation) =>
  operation.getContext().endpoint === "prismic";

const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData: introspectionResult,
});

const createApolloClient = ({ ctx, initialState }) => {
  const link = ApolloLink.from([
    new OperationCounterLink(), //TODO: consider only including this one if cypressBridge is defined
    new DebounceLink(DEFAULT_DEBOUNCE_TIMEOUT),
    createRetryLink(),
    createErrorLink(ctx),
    ApolloLink.split(
      (operation) => isPrismicQuery(operation),
      createPrismicLink(),
      createPenfoldLink(ctx)
    ),
  ]);

  return new ApolloClient({
    link,
    cache: new InMemoryCache({
      // We need to generate custom cache key for types which do not have an id
      // If a const key is used then types from multiple paths will use same cache
      // e.g. portfolio and someMutation.portfolio
      // Note that the :Singleton suffix is just our own internal convention and not an Apollo standard
      dataIdFromObject: (object) => {
        switch (object.__typename) {
          case "Portfolio":
            return "Portfolio:Singleton";
          default:
            return defaultDataIdFromObject(object); // fall back to default handling
        }
      },
      fragmentMatcher,
    }).restore(initialState || {}),
  });
};

export default withApollo(createApolloClient, {});
